module.exports = {
  menstrualCup: { label: '月経カップ', description: '' },
  minimalism: { label: 'ミニマリズム', description: '' },
  review: {
    label: '感想',
    description:
      'M/Mロマンス小説とBLマンガを中心に、心を鷲掴みにされた作品たちへの愛とリスペクトを込めて語り倒します。',
  },
  tvShow: { label: '海外ドラマ', description: '' },
  netflix: { label: 'Netflix', description: '' },
  amazonPrimeVideo: { label: 'Amazonプライムビデオ', description: '' },
  uNext: { label: 'U-NEXT', description: '' },
  englishBook: { label: '洋書', description: '' },
  adrienEnglish: {
    label: 'アドリアン･イングリッシュ',
    description:
      'LAでミステリー専門の本屋を営みながら、推理小説を書いている主人公、アドリアン･イングリッシュと、LAPD殺人課の刑事であり、ゲイであることを受け入れられずにいるジェイク･リオーダン。 二人は事件を解決しながら、お互いの距離を縮め、お互いへの想いを確信していく。 ただのミステリー、ただの恋愛ものでは収まらない、二人の人生の物語。',
  },
  joshLanyon: {
    label: 'ジョシュ･ラニヨン',
    description:
      '米国カリフォルニア州に住むゲイ･ミステリ作家。 60冊を超えるM/Mロマンス小説を執筆し、このジャンルを牽引してしてきた作家の1人。 その作風は、巧妙なミステリーとエキサイティングなアドベンチャー、そして濃厚なゲイロマンスが見事に融合している。 複数の受賞歴を持ち、彼女の作品は11言語に渡って翻訳され、世界中で愛されている。',
  },
  sawaSakura: { label: '紗久楽さわ', description: '' },
  couple: {
    label: 'カップル',
    description:
      'カナダ人のパートナーと出会い、デートを重ね、共同生活を送るようになり、その中で気づき、考え、学んだ、カップルとしての関係を続けるために必要なこと。',
  },
  allsFair: {
    label: "All's Fair",
    description:
      '元FBI特別捜査官で現在は大学で歴史を教えるエリオットと彼の元同僚で元恋人のタッカー。ある事件をきっかけに17ヶ月ぶりに偶然再開し、協力して事件を解決していく過程で、過去と向き合い、何度も衝突しながらも、お互いに無くてはならない存在になっていく。',
  },
  ranmaruZariya: {
    label: '座裏屋蘭丸',
    description:
      '美麗なイラストと妖艶で官能的な性描写、シリアスで骨太なストーリーから、ユーモア溢れる温かいストーリーまで、もう全てが完璧なんじゃないかと思うBL作家さま。 マンガを描いてくださることに日々、感謝しています。',
  },
  zakk: { label: 'ZAKK', description: '' },
  canis: { label: 'CANISシリーズ', description: '' },
  akiUeda: { label: '上田アキ', description: '' },
  relocate: {
    label: '海外移住',
    description:
      '1年間の海外留学のつもりが、カナダが好きになり過ぎて移住してしまいました。その中で日々考えるようになったことや、受けた影響、自分自身の変化について。',
  },
  theArtOfMurder: {
    label: '殺しのアート',
    description:
      '有能だが冷たく人を寄せつけないFBIの行動分析官サム･ケネディと、美術犯罪班のジェイソン･ウエスト。自分の仕事に誇りを持ち、互いに協力し反発しあいながらも事件解決へ向けて全力で捜査を進める中で、交錯するプライドと愛情。',
  },
  audioBook: {
    label: 'オーディオブック',
    description:
      '脳ミソが沸騰しそうなくらい素敵な声で朗読してもらえるオーディオブックのご紹介。M/Mロマンス小説で悶えるもよし、英語学習にも最適。隙間時間にビジネス書を聴いて新たな知識追加も。',
  },
  recommendedManga: {
    label: 'おすすめマンガリスト',
    description: '',
  },
  omad: {
    label: '1日1食',
    description: '',
  },
  fatalShadows: {
    label: '天使の影',
    description: '',
  },
  soThisIsChristmas: {
    label: 'So This Is Christmas',
    description: '',
  },
  eliEaston: {
    label: 'イーライ･イーストン',
    description: '',
  },
  howlAtTheMoon: {
    label: '月吠えシリーズ',
    description: '',
  },
  drugChase: {
    label: 'ドラッグ･チェイス',
    description: '',
  },
  edenWinters: {
    label: 'エデン･ウィンターズ',
    description: '',
  },
  philippeBesson: {
    label: 'フィリップ･ベッソン',
    description: '',
  },
  andreAciman: {
    label: 'アンドレ･アシマン',
    description: '',
  },
  bookClub: {
    label: '読書会',
    description: '',
  },
  chat: {
    label: 'チャットコミュニティ',
    description: '',
  },
  vocabulary: {
    label: '単語',
    description: '',
  },
  noun: {
    label: '名詞',
    description: '',
  },
  adjective: {
    label: '形容詞',
    description: '',
  },
  verb: {
    label: '動詞',
    description: '',
  },
  adverb: {
    label: '副詞',
    description: '',
  },
  idiom: {
    label: 'イディオム',
    description: '',
  },
  phrasalVerb: {
    label: '句動詞',
    description: '',
  },
  slang: {
    label: 'スラング',
    description: '',
  },
  conjunction: {
    label: '接続詞',
    description: '',
  },
  thinkOfEngland: {
    label: 'イングランドを想え',
    description: '',
  },
  kjCharles: {
    label: 'KJ･チャールズ',
    description: '',
  },
  speechless: {
    label: 'Speechless',
    description: '',
  },
  kimFielding: {
    label: 'キム･フィールディング',
    description: '',
  },
  hellOrHighWater: {
    label: 'ヘル･オア･ハイウォーター',
    description: '',
  },
  secretsAndScrabble: {
    label: 'Secrets and Scrabble',
    description: '',
  },
  lilahPace: {
    label: 'ライラ･ペース ',
    description: '',
  },
  hisRoyalSecret: {
    label: 'ロイヤル･シークレット',
    description: '',
  },
  grammar: {
    label: '文法',
    description: '',
  },
}
